import noop from 'lodash/noop';
import { PROJECT_TYPE_CHANGED, INITIALIZE_APP_PROPS, type Action } from './actions';
import type { State } from './types';

const defaultState: State = {
	appProps: {
		onChange: noop,
		projectTypes: [],
		defaultSelected: [],
	},
	selected: [],
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: State = defaultState, action: Action): State => {
	switch (action.type) {
		case INITIALIZE_APP_PROPS: {
			return {
				...state,
				appProps: action.payload,
				selected: action.payload.defaultSelected,
			};
		}

		case PROJECT_TYPE_CHANGED:
			return {
				...state,
				selected: action.payload,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};
